/* eslint-disable jsdoc/require-jsdoc */
import React, { useState } from 'react';
import { getDateForFilter } from '../../../../utils/common';

function CalendarPopupCustomRange({ errorMessage, onChangeDate, onChangeTime }) {
  const [dateFilterValue, setDateFilterValue] = useState(
    { from: getDateForFilter(new Date()), to: getDateForFilter(new Date()) },
  );
  const [timeFilterValue, setTimeFilterValue] = useState({ from: '00:00', to: '23:59' });

  function handleDateChange(fieldKey, selectedDate) {
    const newFilterValue = { ...dateFilterValue, [fieldKey]: selectedDate };
    setDateFilterValue(newFilterValue);
    onChangeDate(newFilterValue);
  }

  function handleTimeChange(fieldKey, selectedTime) {
    const newFilterValue = { ...timeFilterValue, [fieldKey]: selectedTime };
    setTimeFilterValue(newFilterValue);
    onChangeTime(newFilterValue);
  }

  return (
    <div className="calendar__popup-custom-field open">
      <div className="mb-2">From</div>
      <input type="date" className="calendar__popup-input-style mt-2" value={dateFilterValue.from} onChange={(event) => handleDateChange('from', event.target.value)} />

      <input
        type="time"
        className="calendar__popup-input-style mt-2"
        value={timeFilterValue.from}
        onChange={(event) => handleTimeChange('from', event.target.value)}
      />
      <div className="mb-2 mt-2">To</div>
      <input type="date" className="calendar__popup-input-style mt-2" value={dateFilterValue.to} onChange={(event) => handleDateChange('to', event.target.value)} />

      {errorMessage?.toDate && (<div className="error-txt mt-1">{errorMessage?.toDate}</div>)}

      <input
        type="time"
        className="calendar__popup-input-style mt-2"
        value={timeFilterValue.to}
        onChange={(event) => handleTimeChange('to', event.target.value)}
      />
    </div>
  );
}

export default CalendarPopupCustomRange;
